export default {
    common: {
        title: 'Contenido AI',
        socialPlanner: 'Planificador social',
        blog: 'Blog',
        funnel: 'Embudo',
        website: 'Sitio web',
        email: 'Correo electrónico',
        words: 'Palabras',
        variations: 'Variantes',
    },
};
